import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  /** Reseña real. Si está vacía, la tarjeta se muestra como espacio reservado. */
  quote?: string;
  /** Qué debe contar este testimonio cuando llegue el real. */
  brief: string;
  author: string;
  role?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  note?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  note,
  background = 'white'
}: TestimonialsProps) {
  return <section className={`w-full ${background === 'white' ? 'bg-white' : 'bg-ivory'} py-16 sm:py-20`} data-id="element-227" data-mp="31ybfrfgbxji4">
      <div className="mx-auto max-w-6xl px-5" data-id="element-228" data-mp="2x11pxyp135tr">
        {title && <>
            <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-229" data-mp="2s39reltvolgl">
              {title}
            </h2>
            <div className="rule-gold mx-auto mt-6 w-32" aria-hidden="true" data-id="element-230" data-mp="v7c7d8oc59qg" />
          </>}

        <ul className={`grid gap-6 sm:grid-cols-3 ${title ? 'mt-12' : ''}`} data-id="element-231" data-mp="q896m0fe1poa">
          {testimonials.map(testimonial => {
          const isPending = !testimonial.quote;
          return <li key={testimonial.brief} className={`flex flex-col p-7 ${isPending ? 'border border-dashed border-gold-soft bg-ivory/60' : 'border border-gold-soft/70 bg-ivory'}`} data-id="element-232" data-mp="m2ygov544pxd">
                <div className="flex items-center justify-between gap-3" data-id="element-233" data-mp="zysdifsm3ou4">
                  <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-234" data-mp="14ur7ciwplz1x">
                    {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} className={`h-3.5 w-3.5 ${isPending ? 'fill-gold-soft text-gold-soft' : 'fill-gold text-gold'}`} aria-hidden="true" data-id="element-235" data-mp="v5fy8w9toue1" data-mpi={index} />)}
                  </div>
                  {isPending && <span className="text-[9px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-236" data-mp="1sjflj6ei7483">
                      Testimonio pendiente
                    </span>}
                </div>

                {isPending ? <p className="mt-5 flex-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-237" data-mp="1ej4ti01gjjlc">
                    {testimonial.brief}
                  </p> : <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-238" data-mp="19r3n2uqz0n38">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>}

                <div className="mt-6 flex items-center gap-3 border-t border-gold-soft/70 pt-5" data-id="element-239" data-mp="10pnb4ikiccww">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full font-serif text-sm ${isPending ? 'border border-dashed border-gold-soft text-ink-muted' : 'bg-gold-tint text-gold-dark'}`} aria-hidden="true" data-id="element-240" data-mp="vrvnw1ut5ez1">
                    {isPending ? '—' : testimonial.author.charAt(0)}
                  </span>
                  <span data-id="element-241" data-mp="3gg5akn8qfs37">
                    <span className="block text-sm font-semibold text-ink" data-id="element-242" data-mp="3gekpdo8b5li0">
                      {testimonial.author}
                    </span>
                    {testimonial.role && <span className="block text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-243" data-mp="2opr61hmlzs47">
                        {testimonial.role}
                      </span>}
                  </span>
                </div>
              </li>;
        })}
        </ul>

        {note && <p className="mx-auto mt-10 max-w-3xl text-center text-[13px] leading-relaxed text-ink-muted" data-id="element-244" data-mp="20y3se1ecydjv">
            {note}
          </p>}
      </div>
    </section>;
}